var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-container"},[_c('div',{staticClass:"flex shadow-btn",on:{"click":_vm.openCalculator}},[_c('svg-icon',{attrs:{"class-name":"calculator","icon-class":"calculator"}}),_vm._v("计算器\n    ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }